export const METADATA_PAGE_TITLE = 'All New Cars in Singapore | Latest Prices & Listing - Sgcarmart'; // @suppress longLineCheck
export const METADATA_PAGE_DESCRIPTION = 'Looking for a new car? Find & compare latest prices, specifications & detailed info on all new cars for sale in Singapore. The Only Place For Smart Car Buyers.'; // @suppress longLineCheck
export const ICON_SIZE_IN_PIXEL = 14;
export const STAR_ICON_SIZE_IN_PIXEL = 13;
export const TEXTBOX_ICON_SIZE_IN_PIXEL = 20;
